module.exports = __webpack_public_path__ + "sstudio.png?2bf551b196f2f886d55d450a46abcb14";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sstudio.png
// module id = 1015
// module chunks = 2